(function() {
    "use strict";

    angular.module("modules.translations.services", ["gettext"]);
})();
